import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { applyDriveUpdate, DRIVE_UPDATE_EVENT, hasDriveUpdate } from "../../lib/drive/sw";

/** Banner "Nuova versione di Drive": attiva il SW in attesa e ricarica. */
export default function DriveUpdateBanner() {
  const [show, setShow] = useState(() => hasDriveUpdate());
  useEffect(() => {
    const on = () => setShow(true);
    window.addEventListener(DRIVE_UPDATE_EVENT, on);
    return () => window.removeEventListener(DRIVE_UPDATE_EVENT, on);
  }, []);
  if (!show) return null;
  return (
    <div
      role="status"
      data-testid="drive-update-banner"
      className="fixed inset-x-3 z-50 mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-indigo-600 p-3 pl-4 text-white shadow-xl"
      style={{ top: "calc(0.75rem + env(safe-area-inset-top))" }}
    >
      <p className="flex-1 text-sm font-medium">È disponibile una nuova versione di Drive.</p>
      <button
        type="button"
        onClick={() => applyDriveUpdate()}
        className="inline-flex h-11 items-center gap-2 rounded-xl bg-white px-4 text-base font-semibold text-indigo-700 active:bg-indigo-50"
      >
        <RefreshCw className="h-4 w-4" /> Aggiorna
      </button>
    </div>
  );
}
